import { setGetLandingsAction } from '../action';
import { getLandings } from '../api/getLandings';

export const setGetLandings = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getLandings(params);
            dispatch(setGetLandingsAction({
                data: data.data,
                current: 0,
                total: 0
            }))

            if (callback) {
                callback();
            }
            
          
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}